<ng-container *ngIf="enableSurvey$ | async">
  <div class="multi-city-survey-container border rounded-large pr-xsmall">
    <h4 class="font-heading-5">
      {{ 'feedback.multiCitySurveyTitle' | finLocalization }}
    </h4>
    <p class="ms-xxsmall-t">
      <span class="ms-xxsmall-r">
        {{ 'feedback.multiCitySurveyDescription' | finLocalization }}
      </span>
      <fcom-link data-testid="multi-city-survey-link" (afterNavigation)="openSurvey = true">
        {{ 'feedback.multiCitySurveyLinkText' | finLocalization }}
      </fcom-link>
    </p>
  </div>

  <fin-qualtrics [survey]="survey" [(open)]="openSurvey" />
</ng-container>
